import clsx from 'clsx';
import NavbarToggleButton, {
	NavbarToggleButtonProps,
} from '@/components/theme-layouts/components/navbar/NavbarToggleButton';

type NavbarPinToggleButtonProps = NavbarToggleButtonProps & {
	className?: string;
	children?: React.ReactNode;
};

function NavbarPinToggleButton(props: NavbarPinToggleButtonProps) {
	const { ...rest } = props;

	return (
		<NavbarToggleButton
			{...rest}
			className={clsx('rounded-sm', rest.className)}
		/>
	);
}

export default NavbarPinToggleButton;
